import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-test-banner',
  templateUrl: './test-banner.component.html',
  styleUrls: ['./test-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TestBannerComponent implements OnInit {
  public environmentName = environment.environmentName;  
  public displayEnvironmentWarning = environment.displayEnvironmentWarning;
  
  public get title() {
    return environment.environmentName === 'prod' 
      ? ''
      : `${environment.title} (${environment.environmentName})`;
  }

  public get bannerColor(): string {
    switch (environment.environmentName) {
      case 'local':
        return 'deep-space-sparkle';
      case 'dev':
        return 'eye-of-the-tiger';
      case 'test':
        return 'silver-lake-blue';

    }
  }
  constructor() { }

  ngOnInit() {        
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/test-banner/test-banner.component.ts